// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__35gMd","item":"styles_item__2auNh","image":"styles_image__bv6mv","title":"styles_title__3VaJ5","pick":"styles_pick__1r6kU"};